import { CreateReturnWorkflowDto } from "../generated/schema.ts";
import { useApiMutation } from "./use-api-mutation";
import { invalidateAllShopEmailTemplatesKey } from "./use-get-all-shop-email-templates.ts";
import { invalidateAllReturnWorkflowsKey } from "./use-get-all-return-workflows.ts";

export default function useAddReturnWorkflow(shopId: string) {
	return useApiMutation("post", "/shops/{shopId}/return-workflows", {
		notify: false,
		meta: {
			success: {
				title: "workflows.editor.add.success.title",
				message: "workflows.editor.add.success.message",
			},
			error: {
				title: "workflows.editor.add.error.title",
				message: "workflows.editor.add.error.message",
			},
			invalidatesQuery: [
				invalidateAllReturnWorkflowsKey(shopId),
				invalidateAllShopEmailTemplatesKey(shopId),
			],
		},
		mapVariables: ({ requestBody }: { requestBody: CreateReturnWorkflowDto }) => ({
			params: { path: { shopId } },
			body: requestBody,
		}),
	});
}
